import noodleApiClient, { ApiDefinition } from '@noodleApi';

type Input = ApiDefinition['/products/{creatorSlug}/{productSlug}/messages']['GET']['params'];
type Output = ApiDefinition['/products/{creatorSlug}/{productSlug}/messages']['GET']['response'];
const getMessagesByProductId = async ({ creatorSlug, productSlug }: Input): Promise<Output> => {
  const data = await noodleApiClient.get(`/products/${creatorSlug}/${productSlug}/messages`);
  return data.data;
};

export default getMessagesByProductId;